import type { ReactNode, HTMLAttributes } from 'react';
import { Icon, type IconName } from '../../basic/Icon';
import { Button } from '../../basic/Button';
import styles from './EmptyState.module.css';


export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  imgSrc?: string;
  imgAlt?: string;
  icon?: IconName;
  iconNode?: ReactNode;
  title: string;
  description?: string | ReactNode;
  action?: ReactNode;
  iconProps?: Record<string, any>;
  buttonText?: string;
  buttonAction?: () => void;
  maxWidth?: string;
}

export function EmptyState({
  imgSrc,
  imgAlt = 'Empty state content',
  icon,
  iconNode,
  title,
  description,
  action,
  iconProps,
  className,
  buttonText,
  buttonAction,
  maxWidth,
  ...props
}: EmptyStateProps) {
  const classNames = [styles.emptyState, className].filter(Boolean).join(' ');

  const renderVisual = () => {
    if (imgSrc) {
      return (
        <div className={styles.imageWrapper}>
          <img src={imgSrc} alt={imgAlt} className={styles.image} />
        </div>
      );
    }

    if (iconNode) {
      return <div className={styles.iconWrapper}>{iconNode}</div>;
    }

    const finalIcon = icon || 'information';
    return (
      <div className={styles.iconWrapper}>
        <Icon name={finalIcon} size="2xl" {...iconProps} />
      </div>
    );
  };

  return (
    <div className={classNames} {...props}>
      {renderVisual()}
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
      {buttonText && buttonAction && <Button
          variant="primary"
          size="md"
          onClick={buttonAction}
        >
          {buttonText}
      </Button>}
    </div>
  );
}
